import React, { useEffect, useState } from "react";
import { ArrowUp } from "lucide-react";

export const BackToTop = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 400);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <button
      type="button"
      data-testid="back-to-top-btn"
      onClick={scrollToTop}
      aria-label="Voltar ao topo"
      title="Voltar ao topo"
      className={`fixed bottom-40 right-6 z-40 w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-[#163A6D] hover:bg-[#FF5A00] border border-[#2F568F] hover:border-[#FF5A00] text-white shadow-lg transition-all duration-300 ${
        visible
          ? "opacity-100 translate-y-0 pointer-events-auto"
          : "opacity-0 translate-y-4 pointer-events-none"
      }`}
    >
      <ArrowUp className="w-5 h-5 md:w-6 md:h-6" strokeWidth={2.2} />
    </button>
  );
};

export default BackToTop;
